import { useApiClient } from "../../../apiClient";

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { GET_COACH_QUERY_KEY } from "./useGetCoach";

export const useUpdateCoachAvatar = (id: string) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['updateCoachAvatar', id],
        mutationFn: async (file: File) => {
            const formData = new FormData();
            formData.append('avatar', file);
            return apiClient.fetchApiWithFormData<CoachDto>({
                endpoint: `coachs/${id}/avatar`,
                method: 'POST',
                formData
            });
        },
        onSuccess: (response) => {
            queryClient.setQueryData<CoachDto>(GET_COACH_QUERY_KEY(id), response);
        }
    });
};